// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notificationcontent_oGj0z {
  padding-top: 10px;
  line-height: 1px;
  width: 100%;
  height: 400px;
  overflow-y: auto;
}
.messagestyle_ohdSs {
  color: blue;
  border-bottom: 1px solid blue;
  padding-bottom: 20px;
  padding-top: 10px;
  cursor: pointer;
}
.messagestyle2_Dla0a {
  color: initial;
  border-bottom: 1px solid #98a0ab;
  padding-bottom: 20px;
  padding-top: 10px;
  cursor: pointer;
}
.contrinert_rVH4u {
  line-height: 2px;
  text-align: center;
}
.notificationCount_p93ea {
  font-weight: 700;
  bottom: 0;
}
.contentDisplay_chWkj {
  text-align: center;
  font-weight: 700;
  margin-bottom: 20;
}
.contentContainer_sDvMT {
  color: #98a0ab;
  width: 100%;
  margin-top: 10px;
  display: flex;
  align-items: center;
  height: auto;
}
.messageHeading_D87po {
  width: 380;
  /* Set width of the box */
  font-weight: 700;
  color: black;
}
.hours_WJevm {
  display: flex;
  flex-direction: row;
  font-size: 12px;
  line-height: 2px;
}
.actinbutton_MRGgr {
  margin-left: auto;
}
.imageStyle_v4klM {
  width: 50px;
  height: 50px;
}
.textContent_fuw0e {
  margin-left: 10px;
}
.content_a2uDG {
  font-size: 12px;
  line-height: auto;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Notification/notification.less"],"names":[],"mappings":"AAAA;EACI,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;AACJ;AAEA;EACI,WAAA;EACA,6BAAA;EACA,oBAAA;EACA,iBAAA;EACA,eAAA;AAAJ;AAEA;EACI,cAAA;EACA,gCAAA;EACA,oBAAA;EACA,iBAAA;EACA,eAAA;AAAJ;AAGA;EACI,gBAAA;EACA,kBAAA;AADJ;AAGA;EACI,gBAAA;EACA,SAAA;AADJ;AAIA;EACI,kBAAA;EACA,gBAAA;EACA,iBAAA;AAFJ;AAIA;EACI,cAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AAFJ;AAIA;EACI,UAAA;EAFF,yBAAyB;EAGvB,gBAAA;EACA,YAAA;AADJ;AAGA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AADJ;AAGA;EACI,iBAAA;AADJ;AAGA;EACI,WAAA;EACA,YAAA;AADJ;AAGA;EACI,iBAAA;AADJ;AAGA;EACI,eAAA;EACA,iBAAA;AADJ","sourcesContent":[".notificationcontent {\n    padding-top: 10px;\n    line-height: 1px;\n    width: 100%;\n    height: 400px;\n    overflow-y: auto;\n}\n\n.messagestyle {\n    color: blue;\n    border-bottom: 1px solid blue;\n    padding-bottom: 20px;\n    padding-top: 10px;\n    cursor: pointer;\n}\n.messagestyle2 {\n    color: initial;\n    border-bottom: 1px solid #98a0ab;\n    padding-bottom: 20px;\n    padding-top: 10px;\n    cursor: pointer;\n}\n\n.contrinert {\n    line-height: 2px;\n    text-align: center;\n}\n.notificationCount {\n    font-weight: 700;\n    bottom: 0;\n}\n\n.contentDisplay {\n    text-align: center;\n    font-weight: 700;\n    margin-bottom: 20;\n}\n.contentContainer {\n    color: #98a0ab;\n    width: 100%;\n    margin-top: 10px;\n    display: flex;\n    align-items: center;\n    height: auto;\n}\n.messageHeading {\n    width: 380; /* Set width of the box */\n    font-weight: 700;\n    color: black;\n}\n.hours {\n    display: flex;\n    flex-direction: row;\n    font-size: 12px;\n    line-height: 2px;\n}\n.actinbutton {\n    margin-left: auto;\n}\n.imageStyle {\n    width: 50px;\n    height: 50px;\n}\n.textContent {\n    margin-left: 10px;\n}\n.content {\n    font-size: 12px;\n    line-height: auto;\n}\n\n@primary-color: #2FB153;@link-color: #1DA57A;@border-radius-base: 2px;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"notificationcontent": `notificationcontent_oGj0z`,
	"messagestyle": `messagestyle_ohdSs`,
	"messagestyle2": `messagestyle2_Dla0a`,
	"contrinert": `contrinert_rVH4u`,
	"notificationCount": `notificationCount_p93ea`,
	"contentDisplay": `contentDisplay_chWkj`,
	"contentContainer": `contentContainer_sDvMT`,
	"messageHeading": `messageHeading_D87po`,
	"hours": `hours_WJevm`,
	"actinbutton": `actinbutton_MRGgr`,
	"imageStyle": `imageStyle_v4klM`,
	"textContent": `textContent_fuw0e`,
	"content": `content_a2uDG`
};
export default ___CSS_LOADER_EXPORT___;
